import { apiSlice } from '../apiSlice'

export const spendingCategoriesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    addSpendingCategory: builder.mutation({
      query: (data) => ({
        url: '/spending-categories/add-category',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: () => [
        { type: 'spending-categories' }, // Invalidate the customer list (only if required)
      ],
    }),

    getAllSpendingCategory: builder.query({
      query: () => `/spending-categories`,
      keepUnusedDataFor: 6000,
      providesTags: (result) => {
        if (result?.content && Array.isArray(result.content)) {
          return [
            { type: 'spending-categories' }, // provides tag for Customer list
            ...result.content.map(({ id }) => ({
              type: 'spending-category',
              id,
            })), // provides tag for individual category
          ]
        }
        return [{ type: 'spending-categories' }] // fallback in case content is not available
      },
    }),

    getSpendingCategoryById: builder.query({
      query: (id) => `/spending-categories/category/${id}`,
      providesTags: (result, error, id) => [
        { type: 'category', id }, // Provides a tag for a single customer
      ],
    }),

    updateSpendingCategory: builder.mutation({
      query: (data) => ({
        url: '/spending-categories/update-category',
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'spending-category', id }, // Invalidate the cache for the updated customer
        { type: 'spending-categories' }, // Optionally invalidate the customers list (only if required)
      ],
    }),
    deleteSpendingCategory: builder.mutation({
      query: (id) => ({
        url: `/spending-categories/category/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: () => [{ type: 'categories' }],
    }),
  }),
})

export const {
  useAddSpendingCategoryMutation,
  useGetAllSpendingCategoryQuery,
  useGetSpendingCategoryByIdQuery,
  useUpdateSpendingCategoryMutation,
  useDeleteSpendingCategoryMutation,
} = spendingCategoriesApi
